module.exports = __webpack_public_path__ + "static/media/ruzencova-pout-2024-program.a8e71de9.jpg";